import { commonjsGlobal as u } from "./index.es469.js";
import { __module as f } from "./index.es497.js";
var L = f.exports, y;
function x() {
  return y ? f.exports : (y = 1, (function(h, R) {
    (function(v, i) {
      i();
    })(L, function() {
      function v(e, t) {
        return typeof t > "u" ? t = { autoBom: !1 } : typeof t != "object" && (console.warn("Deprecated: Expected third argument to be a object"), t = { autoBom: !t }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\uFEFF", e], { type: e.type }) : e;
      }
      function i(e, t, r) {
        var o = new XMLHttpRequest();
        o.open("GET", e), o.responseType = "blob", o.onload = function() {
          l(o.response, t, r);
        }, o.onerror = function() {
          console.error("could not download file");
        }, o.send();
      }
      function m(e) {
        var t = new XMLHttpRequest();
        t.open("HEAD", e, !1);
        try {
          t.send();
        } catch {
        }
        return 200 <= t.status && 299 >= t.status;
      }
      function c(e) {
        try {
          e.dispatchEvent(new MouseEvent("click"));
        } catch {
          var t = document.createEvent("MouseEvents");
          t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
        }
      }
      var a = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof u == "object" && u.global === u ? u : void 0, w = a.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), l = a.saveAs || (typeof window != "object" || window !== a ? function() {
      } : "download" in HTMLAnchorElement.prototype && !w ? function(e, t, r) {
        var o = a.URL || a.webkitURL, n = document.createElement("a");
        t = t || e.name || "download", n.download = t, n.rel = "noopener", typeof e == "string" ? (n.href = e, n.origin === location.origin ? c(n) : m(n.href) ? i(e, t, r) : c(n, n.target = "_blank")) : (n.href = o.createObjectURL(e), setTimeout(function() {
          o.revokeObjectURL(n.href);
        }, 4e4), setTimeout(function() {
          c(n);
        }, 0));
      } : "msSaveOrOpenBlob" in navigator ? function(e, t, r) {
        if (t = t || e.name || "download", typeof e != "string") navigator.msSaveOrOpenBlob(v(e, r), t);
        else if (m(e)) i(e, t, r);
        else {
          var o = document.createElement("a");
          o.href = e, o.target = "_blank", setTimeout(function() {
            c(o);
          });
        }
      } : function(e, t, r, o) {
        if (o = o || open("", "_blank"), o && (o.document.title = o.document.body.innerText = "downloading..."), typeof e == "string") return i(e, t, r);
        var n = e.type === "application/octet-stream", E = /constructor/i.test(a.HTMLElement) || a.safari, b = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((b || n && E || w) && typeof FileReader < "u") {
          var d = new FileReader();
          d.onloadend = function() {
            var s = d.result;
            s = b ? s : s.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = s : location = s, o = null;
          }, d.readAsDataURL(e);
        } else {
          var g = a.URL || a.webkitURL, p = g.createObjectURL(e);
          o ? o.location = p : location.href = p, o = null, setTimeout(function() {
            g.revokeObjectURL(p);
          }, 4e4);
        }
      });
      a.saveAs = l.saveAs = l, h.exports = l;
    });
  })(f), f.exports);
}
export {
  x as __require
};
//# sourceMappingURL=index.es471.js.map
